import { usePrintCheckpointQrCodes } from '../hooks/usePrintCheckpointQrCodes'
import { useTranslation } from 'react-i18next'
import { MdPrint } from 'react-icons/md'

import {
  Flex,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { Modal } from '@/components/overlays'
import { Button } from '@/components/ui'

import { CheckpointIProps } from '../../types/types'
import { BulkPrintBody } from './BulkPrintBody'

interface BulkPrintModalIProps {
  isOpen: boolean
  onClose: () => void
  checkpoints: CheckpointIProps[]
  facilityId: string
}

export const BulkPrintModal = ({
  isOpen,
  onClose,
  checkpoints,
  facilityId,
}: BulkPrintModalIProps) => {
  const { t } = useTranslation()
  const { print, printRef, totalPages } = usePrintCheckpointQrCodes({
    checkpoints,
    facilityId,
    onClose,
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='xl'>
      <ModalOverlay data-testid='bulkPrintModal_overlay' />
      <ModalContent bg='#fff' data-testid='bulkPrintModal_content' maxW='700px'>
        <ModalHeader>
          <Flex alignItems='center' gap={2}>
            <MdPrint size={24} />
            <Text>{t('floors:print_modal_title')}</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton data-testid='bulkPrintModal_closeButton' />
        <ModalBody>
          <BulkPrintBody
            checkpoints={checkpoints}
            printRef={printRef}
            totalPages={totalPages}
          />
        </ModalBody>
        <ModalFooter gap={3}>
          <Button
            data-testid='bulkPrintModal_cancelButton'
            onClick={onClose}
            variant='secondary'
          >
            {t('common:cancel')}
          </Button>
          <Button
            data-testid='bulkPrintModal_printButton'
            leftIcon={<MdPrint size={20} />}
            onClick={print}
          >
            {t('floors:print_action')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
